module.exports = __webpack_public_path__ + "static/media/image10.4d7c27a0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/OurTeam/image10.jpeg
// module id = 120
// module chunks = 0